import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

/**
 * Base schema for social export forms with common validations.
 * All platform-specific schemas should extend from this.
 * Accepts a message formatter (e.g. $t) for translated validation messages.
 */
export function getBaseExportSchema(t: MessageFormatter) {
  return z.object({
    publishAt: z
      .string()
      .nullable()
      .refine(
        (value) => {
          if (!value) return true;
          const minDateTime = new Date(Date.now() + 2 * 60 * 1000);
          return new Date(value) > minDateTime;
        },
        {
          message: t({
            id: 'socialExport.validation.futureDate',
            defaultMessage: 'Date must be in the future',
          }),
        },
      ),
  });
}

/**
 * @deprecated Use getBaseExportSchema(t) for translated messages
 */
export const baseExportSchema = getBaseExportSchema((msg) => msg.defaultMessage);
